<template lang="html">
  <div style="border:0px solid red;height:100%;" ref="chart_container">
    <svg id="gantt_chart"></svg>
  </div>
</template>

<script lang="js">

import Vue from 'vue'
import settings from "@/settings.coffee"
import * as d3 from 'd3';

export default {
    name: 'GanttChart',
    props:{
        options: null,
        updateData: null
    },
    data: function(){
        return {
            lastTransform: d3.zoomIdentity,
            barHeight: 30,
            width: 400 ,
            startStr: new Date(new Date().getTime() - (1000 * 3600 * 24 * 180)),
            endStr: new Date(new Date().getTime() + (1000 * 3600 * 24 * 180))

        }
    },
    methods: {
        cleanUpData: function(data){
            let cleanedData = data.map(function(el){
                return {
                    start: new Date(new Date(el.start).getTime() - (1000 * 3600 * 2)),
                    end: new Date(new Date(el.end).getTime() - (1000 * 3600 * 2)),
                    title: el.extendedProps.user_fullnamejobs.split("(")[0]+" "+el.extendedProps.item_type,
                    color: el.color,
                    uid: el.extendedProps.item_uid
                }
            })
            cleanedData = cleanedData.sort(function(a, b){
                return a.start.getTime()-b.start.getTime();
            })
            return cleanedData
        },
        refreshGraph: function(data){
            var bars = d3.select("#gantt_chart").selectAll(".bars")
                .selectAll(".bar")
                .data(data)

            bars.exit().remove()
            
            var bar = bars
                .enter()
                .append("g")
                .attr("class", "bar")
	        .attr("transform", function(d, i) {
                    let yPos = i*(self.barHeight + self.barPadding)
                    let ret = "translate(" + self.x(d.start) + "," + self.y(i) + ")"
	            return ret;
                })
                .on("mouseover", function(e, d){
                    console.log("over")
                    let begin = `${d.start.toLocaleDateString()}`
                    let finish = `${d.end.toLocaleDateString()}`
                    
                    if(d.start.toLocaleTimeString() != "00:00:00"){
                        begin += ` ${d.start.toLocaleTimeString()}`
                        finish += ` ${d.end.toLocaleTimeString()}`
                    }else{
                    }
                    
                    let text = `<b>${d.title}</b><br>`+
                      `Début: ${begin}<br>`+
                      `Fin: ${finish}`
                    self.tooltip.html(text);
                    return self.tooltip
                        .style("visibility","visible")
                        .transition().duration(60).style("opacity", "1");
                })
                .on("mousemove", function(e){
                    return self.tooltip.style("top", (e.pageY-95)+"px").style("left",(e.pageX-140)+"px");
                })
                .on("mouseout", function(){return self.tooltip.style("visibility","hidden").style("opacity", "0");})

            bar.append("rect").transition()
                .attr("rx", 5)
                .attr("ry", 5)
	        .attr("y", self.barHeight*0.25)
	        .attr("height", function(d) { return self.barHeight })
	        .attr("width", function(d) { 
	            return Math.max(20, (self.x(d.end) - self.x(d.start)) ); 
	        })
                .attr("fill", function(d){return d.color})

            bar.append("text").transition()
                .attr("pointer-events", "none")
                .attr("x", 10)
                .attr("y", self.barHeight*0.75)
                .attr("dy", ".35em")
                .text(function(d){
                    let width = (self.x(d.end) - self.x(d.start))
                    return d.title.substring(0, width/8)
                })

            bars
	        .attr("transform", function(d, i) {
                    let yPos = i*(self.barHeight + self.barPadding)
                    let ret = "translate(" + self.x(d.start) + "," + self.y(i) + ")"
	            return ret;
                })
            
            bars.transition()
                .select("rect")
                .attr("rx", 5)
                .attr("ry", 5)
	        .attr("y", self.barHeight*0.25)
	        .attr("height", function(d) { return self.barHeight })
	        .attr("width", function(d) { 
	            return Math.max(20, (self.x(d.end) - self.x(d.start)) ); 
	        })
                .attr("fill", function(d){return d.color})

            bars.transition()
                .select("text")
                .attr("x", 10)
                .attr("y", self.barHeight*0.75)
                .attr("dy", ".35em")
                .text(function(d){
                    let width = (self.x(d.end) - self.x(d.start))
                    return d.title.substring(0, width/8)
                })

            
            
        },
        refreshData: function(){
            self = this
            
            self.options.events({
                startStr: self.startStr.toISOString().split("T")[0],
                endStr: self.endStr.toISOString().split("T")[0]},
                function(data){
                    let cleanedData = self.cleanUpData(data)
                    self.refreshGraph(cleanedData)
            })
           


                        
        },
        initChart: function(data){
            
            self = this
            
            let width = this.$refs.chart_container.offsetWidth ;
            self.width = this.$refs.chart_container.offsetWidth;
            let height = this.$refs.chart_container.offsetHeight;
            let barPadding = 5
            let yAxisWidth = 0;
            let margin = ({top: 30, right: 10, bottom: 30, left: 10})
            
            let svg = d3.select("#gantt_chart")
                .attr("width", width)
                .attr("height", height);
            svg.selectAll("*").remove();
            svg.append("clipPath")
                .attr("id", "clip")
                .append("rect")
                .attr("x", yAxisWidth + margin.left)
                .attr("y", margin.top)
                .attr("width", width - yAxisWidth - margin.right - margin.left)
                .attr("height",height - margin.top);
           
            const gx = svg.append("g");
            const gy = svg.append("g");
            
            var now = new Date();
            var start = new Date();
            start.setDate(now.getDate() - 15);
            var end = new Date();
            end.setDate(now.getDate() + 15);
            
            var days = Math.ceil((end.getTime() - start.getTime()) / (1000 * 3600 * 24));
            let weeksData = []
            let firstWeek = new Date(self.startStr)
            firstWeek.setMilliseconds(0)
            firstWeek.setSeconds(0)
            firstWeek.setMinutes(0)
            firstWeek.setHours(0)
            firstWeek = new Date(firstWeek.getTime() - (1000 * 3600 * 24) * (start.getDay()-2))

            let k = 0;
            let endWeek = new Date(firstWeek.getTime() + k*(1000 * 3600 * 24 * 7) + 5*(1000 * 3600 * 24))
            while(k < 52){
                endWeek = new Date(firstWeek.getTime() + k*(1000 * 3600 * 24 * 7) + 5*(1000 * 3600 * 24))
                weeksData.push({
                    start: new Date(firstWeek.getTime() + k*(1000 * 3600 * 24 * 7)),
                    end: endWeek,
                    weekNum: k
                })

                k++
            }

            console.log("weeksData",weeksData)
            
            var x = d3.scaleTime()
                .domain([start,end])
                .range([yAxisWidth+margin.left, width - margin.right])

            self.x = x;
            
            var xAxis = svg.append("g")
                .attr("transform","translate(0,10)")
                .call(d3.axisBottom(x).ticks(5));

            let y = d3.scaleLinear()
                .domain([0, data.length])
                .range([20,(barPadding+self.barHeight)*data.length])
            self.y = y;
            
            let yAxis = (g, scale) => g
                .attr("transform", "translate("+ yAxisWidth +",10)")
                .call(d3.axisLeft(scale))
                .call(g => g.select(".domain").attr("display", "none"))

            // weeks
            var weeks = svg.append("g")
                .attr("class", "weeks")
                .attr("clip-path", "url(#clip)")

            weeks
                .selectAll('.week')
                .data(weeksData)
                .enter()
                .append('rect')
                .attr("class", "week")
	        .attr("transform", function(d, i) {
                    let newtrans = "translate(" + x(d.start) + "," + 0 + ")"
	            return newtrans;
                })
                .attr("width", function(d, i) {
	            return (x(d.end) - x(d.start)); 
	        })
                .attr("height", function(d) { 
	            return 1000; 
	        })
                .attr("fill", "#DEDEDE")

            
            var tooltip = d3.select("body")
                .append("div")
                .attr("class", "d3-tool-tip")
                .style("position", "fixed")
                .style("z-index", "10")
                .style("opacity", "0")
                .text("")
            self.tooltip = tooltip
            
            var bars = svg.append("g")
                .attr("class", "bars")
                .attr("clip-path", "url(#clip)")
           
            self.refreshGraph(data)
                        
            // Zoom:
            const zoomX = d3.zoom();
            const zoomY = d3.zoom();
            zoomY.translateExtent([
                [0, -20], [Infinity, data.length*(barPadding+self.barHeight)+margin.bottom]]);
            const tx = () => d3.zoomTransform(gx.node());
            const ty = () => d3.zoomTransform(gy.node());
            gx.call(zoomX).attr("pointer-events", "none");
            gy.call(zoomY).attr("pointer-events", "none");

            var zoom = d3.zoom()
            if (data.length > 0)
                zoom.translateExtent([[x(data[0].start)-300, 0], [x(data[data.length-1].end)+300, Infinity]])
            zoom.on("zoom", function(e) {
                    var newX = e.transform.rescaleX(x);
                    self.x = newX;
                    xAxis.call(d3.axisBottom(newX))

                    const t = e.transform;
                    const k = t.k / self.lastTransform.k;
                    
                    // transaltion ?
                    if(e.transform.k == self.lastTransform.k){
                        gy.call(zoomY.translateBy, 0, (t.y - self.lastTransform.y) / ty().k);
                    }

                    const yr = ty().rescaleY(y);
                    
                    gy.call(yAxis, yr);
                    self.y = yr;

                    let bar = svg.selectAll(".bar")
	                .attr("transform", function(d, i) {
                            let newtrans = "translate(" + newX(d.start) + "," + yr(i) + ")"
	                    return newtrans;
                        })

                    bar.select('rect')
                    	.attr("width", function(d) { 
	                    return Math.max(20,  (newX(d.end) - newX(d.start)) ); 
	                })

                    bar.select('text')
                        .text(function(d){
                            let width = (newX(d.end) - newX(d.start))
                            let ind = Math.ceil((width-20)/8)
                            return d.title.substring(0, ind)
                        })

                    let week = svg.selectAll(".week")
	                .attr("transform", function(d, i) {
                            let newtrans = "translate(" + newX(d.start) + "," + 0 + ")"
	                    return newtrans;
                        })
                        .attr("width", function(d, i) {
	                    return (newX(d.end) - newX(d.start)); 
	                })
                    
                    self.lastTransform = t
                })
            
            svg.call(zoomY)
            svg.call(zoom);            
        },
        fetchData: function(){
            self = this;
            self.options.events({
                startStr: self.startStr.toISOString().split("T")[0],
                endStr: self.endStr.toISOString().split("T")[0]},
                function(data){
                    let cleanedData = self.cleanUpData(data)
                    self.initChart(cleanedData)
            })

        }
    },
    mounted: function(){
        self = this
        setTimeout(function(){
            self.fetchData()
        }, 1)
        
    },
    watch:{
        'updateData': function(a, b){
            self = this
            setTimeout(function(){
                self.refreshData()
            }, 1)
        }
    }
    
    
}
  
</script>

<style>
  .d3-tool-tip{
  padding: 10px;
  background-color:white;
  border: 0px solid grey;
  border-radius:3px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  }
</style>
